import { Country } from './country';
import { Entity } from './entity';

export class EntityType {
  entityTypeId!: number;
  countryId!: number;
  name!: string;
  description!: string;
  isActive!: boolean;
  isDefault!: boolean;
  created!: Date;
  createdBy!: string;
  modified!: Date;
  modifiedBy!: string;
  country!: Country;
  entities!: Entity[];
}
